import {
	getParticularForm,
	getParticularFormData,
	postCandInfo,
	postCandInterSkills,
	postCandSkills,
} from "@/utils/apiFunctions";
import Selectwithsearch from "@/components/selectwithsearch.vue";
import InputField from "@/components/InputComponents/Input.vue";
import ExpertiseLevel from "@/components/InputComponents/ExpertiseLevel.vue";
import { columnWidth, dynamicRules, showError } from "@/utils/customField";
import Loader from "@/components/fixedcomponents/Loader.vue";
import toast from "@/components/mixin/toast";
import { mapGetters } from "vuex";
import { trackFormSubmitted } from "@/utils/posthogHelpers";
export default {
	name: "CommonForm",
	data() {
		return {
			isFirst: true,
			techSkillLoader: false,
			interSkillLoader: false,
			hobbyLoader: false,
			techShimmer: true,
			interShimmer: true,
			hobbyShimmer: false,
			loader: false,
			techSkillEdit: false,
			hobbyEdit: false,
			interSkillEdit: false,
			selectedIndex: null,
			isHobbyParser: false,
			hobbiesMandatory: false,
			techSkills: [],
			parserTechSkills: [],
			interSkills: [],
			parserInterSkills: [],
			hobbies: [],
			parserHobbies: [],
			parserHobbieTrigger: false,
			techSkillsFields: [],
			techCustomFieldsArray: [],
			techSkillObject: {},
			techtouchedFields: {},
			techValidations: {},
			techValText: {},
			selectedTechSkill: {},

			interSkillsFields: [],
			interCustomFieldsArray: [],
			interSkillObject: {},
			intertouchedFields: {},
			interValidations: {},
			interValText: {},
			selectedInterSkill: {},

			hobbyFields: [],
			hobbyCustomFieldsArray: [],
			hobbyObject: {},
			hobbytouchedFields: {},
			hobbyValidations: {},
			hobbyValText: {},
			selectedHobby: "",

			touchedFields: {},
			hideSuggestList: false,
			originalTechSkills: [],
			originalInterSkills: [],
			originalHobbies: [],
		};
	},
	mixins: [toast],
	components: {
		InputField,
		Selectwithsearch,
		ExpertiseLevel,
		Loader,
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfo: "getcandidateInfo",
			checkDynamic: "getAllValidation",
		}),
	},
	props: {
		singleData: Object,
		formType: String,
	},

	created() {
		this.getSkillsData();
		this.getInterPersonalData();
		this.getHobbyData();
		this.getTechSkillFields("add");
		this.getInterSkillFields("add");
		this.getHobbyFields("add");
	},
	methods: {
		storeOriginalData() {
			this.originalTechSkills = JSON.parse(JSON.stringify(this.techSkills));
			this.originalInterSkills = JSON.parse(JSON.stringify(this.interSkills));
			this.originalHobbies = JSON.parse(JSON.stringify(this.hobbies));
		},
		hasUnsavedChanges() {
			return (
				!this.deepEqual(this.techSkills, this.originalTechSkills) ||
				!this.deepEqual(this.interSkills, this.originalInterSkills) ||
				!this.deepEqual(this.hobbies, this.originalHobbies)
			);
		},
		filteredOptions(array1, array2) {
			// Filter array1 by checking if no object in array2 matches the condition
			return array1.filter((data1) => {
				// Use .some() to check if any object in array2 matches the key in data1 (case-insensitive)
				return !array2.some(
					(data2) => data2.skillName?.toLowerCase() === data1.key?.toLowerCase()
				);
			});
		},
		onTechSkillFocus() {
		},
		onTechSkillInput(value) {
		},
		onTechSkillSelectValue(field, value) {
			this.updateTechFieldValue(field, value);
		},
		filteredHobbyOptions(array1, array2) {
			return array1.filter((data1) => {
				// Check if there's no object in array2 with skillName matching data1.key
				return !array2.some(
					(data2) => data2.toLowerCase() == data1.label.toLowerCase()
				);
			});
		},
		async getSkillsData() {
			try {
				const res = await getParticularFormData("skills");

				if (res.status == 200) {
					this.techSkills = (res.data.data) ? res.data.data.filter((data) => {
						return (
							data.parser == null ||
							data.parser == false ||
							data.parser == undefined
						);
					}) : [];
					this.parserTechSkills = (res.data.data) ? res.data.data.filter((data) => {
						return data.parser == true;
					}) : [];
					this.techShimmer = false;
				}
			} finally {
				if (this.$route.query.id && this.isFirst) {
					console.log(
						this.$route.query.id,
						"this.$route.query.idthis.$route.query.idthis.$route.query.idthis.$route.query.id"
					);
					if (
						this.$route.query.id.includes("SKILL") &&
						!this.$route.query.id.includes("INTERPERSONALSKILL")
					) {
						const matchedObject =
							this.techSkills.find(
								(item) => item.uniqueID === this.$route.query.id
							) ||
							this.parserTechSkills.find(
								(item) => item.uiqueID === this.$route.query.id
							);
						if (matchedObject) {
							this.techSkillObject = { ...matchedObject };
							this.selectedTechSkill = { ...matchedObject };
							this.techSkillEdit = true;
						}
					}
				}
				this.storeOriginalData();
			}
		},
		async getInterPersonalData() {
			try {
				const res = await getParticularFormData("interpersonalSkills");
				if (res.status == 200) {
					this.interSkills = (res.data.data) ? res.data.data.filter((data) => {
						return (
							data.parser == null ||
							data.parser == false ||
							data.parser == undefined
						);
					}) : [];
					this.parserInterSkills = (res.data.data) ? res.data.data.filter((data) => {
						return data.parser == true;
					}) : [];
					this.interShimmer = false;
				}
			} catch (error) {
				throw new Error(error);
			} finally {
				if (this.$route.query.id && this.isFirst) {
					console.log(
						this.$route.query.id,
						"this.$route.query.idthis.$route.query.idthis.$route.query.idthis.$route.query.id"
					);

					if (/^INTERPERSONALSKILL\d*$/.test(this.$route.query.id)) {
						console.log("llllllllllllllllllllllll");
						const matchedObject =
							this.interSkills.find(
								(item) => item.uniqueID === this.$route.query.id
							) ||
							this.parserInterSkills.find(
								(item) => item.uiqueID === this.$route.query.id
							);
						if (matchedObject) {
							this.interSkillObject = matchedObject;
							this.selectedInterSkill = matchedObject;
							this.interSkillEdit = true;
						}
					}
				}
				this.storeOriginalData();
			}
		},
		async getHobbyData() {
			try {
				const res = await getParticularFormData("hobbies");
				if (res.status == 200) {
					this.hobbies = (res.data.hobbies) ? res.data.hobbies : [];
					console.log("hobbies kejrrrrrrrrrrrrrrrrrrrr", this.hobbies);
					this.parserHobbies = res.data.parser_hobbies;
					if (this.parserHobbies && this.parserHobbies.length > 0) {
						this.parserHobbieTrigger = true;
					}
					this.hobbyShimmer = false;
				}
			} catch (error) {
				throw new Error(error);
			} finally {
				if (this.$route.query.id && this.isFirst) {
					console.log(
						this.$route.query.id,
						"this.$route.query.idthis.$route.query.idthis.$route.query.idthis.$route.query.id",
						this.formID
					);

					if (this.$route.query.formID === "hobbies") {
						console.log("llllllllllllllllllllllll");

						// Find the matched data in either hobbies or parserHobbies
						const matchedData =
							this.hobbies.find((item) => item === this.$route.query.id) ||
							this.parserHobbies.find((item) => item === this.$route.query.id);
						console.log(matchedData, "matc");

						if (matchedData) {
							// Update the hobby-related properties
							this.hobbyObject.hobbies = matchedData;
							this.selectedHobby = matchedData;
							this.hobbyEdit = true;

							// Update selectedIndex with the index of the matched data
							// Find index in the first array (this.hobbies), or fall back to parserHobbies if not found
							const indexInHobbies = this.hobbies.indexOf(matchedData);
							const indexInParserHobbies =
								this.parserHobbies.indexOf(matchedData);

							// Set selectedIndex based on where the matched data was found
							if (indexInHobbies !== -1) {
								this.selectedIndex = indexInHobbies; // Found in hobbies
							} else if (indexInParserHobbies !== -1) {
								this.selectedIndex = indexInParserHobbies; // Found in parserHobbies
							}
						}
					}
				}
				this.storeOriginalData();
			}
		},
		async getTechSkillFields(type) {
			try {
				this.techSkillLoader = true;
				this.techSkillObject = {};
				this.selectedTechSkill = {};
				this.techCustomFieldsArray = [];
				this.techtouchedFields = {};
				this.techValidations = {};
				this.techSkillsFields = [];

				const customFields = await this.getStaticCustomFields("skills", type);

				if (customFields.length) {
					if (type == "add") {
						[
							this.techCustomFieldsArray,
							this.techSkillObject,
							this.techtouchedFields,
						] = customFields;
					} else {
						[this.techCustomFieldsArray, this.techtouchedFields] = customFields;
					}

					// Iterate through the original array and push objects into respective arrays based on category value
					this.techCustomFieldsArray.forEach((obj) => {
						if (obj.category === 1 || obj.category === null) {
							this.techSkillsFields.push(obj); // Push objects with category value 1 into category1Array
						}
					});

					this.techValidations = dynamicRules(this.techCustomFieldsArray);
					console.log(
						this.techSkillObject,
						"techSkillObject",
						this.techSkillObject["skillName"]
					);
				}
			} catch (error) {
				throw new Error(error);
			} finally {
				if (
					this.singleData &&
					(this.formType == "edit" || this.formType == "editParser") &&
					this.isFirst
				) {
					// Match SKILL0, SKILL1, ... but exclude INTERPERSONALSKILL
					if (
						this.singleData.uniqueID &&
						this.singleData.uniqueID.includes("SKILL") &&
						!this.singleData.uniqueID.includes("INTERPERSONALSKILL")
					) {
						this.selectedTechSkill = { ...this.singleData };
						this.techSkillObject = { ...this.singleData };
						this.techSkillEdit = true;
					}
				}
				this.techSkillLoader = false;
			}
		},
		async getInterSkillFields(type) {
			try {
				this.interSkillLoader = true;
				this.interSkillObject = {};
				this.selectedInterSkill = {};
				this.interCustomFieldsArray = [];
				this.intertouchedFields = {};
				this.interValidations = {};
				this.interSkillObject = {};
				this.interSkillsFields = [];
				const customFields = await this.getStaticCustomFields(
					"interpersonalSkills",
					type
				);

				if (customFields.length) {
					if (type == "add") {
						[
							this.interCustomFieldsArray,
							this.interSkillObject,
							this.intertouchedFields,
						] = customFields;
					} else {
						[this.interCustomFieldsArray, this.intertouchedFields] =
							customFields;
					}

					// Iterate through the original array and push objects into respective arrays based on category value
					this.interCustomFieldsArray.forEach((obj) => {
						if (obj.category === 1 || obj.category === null) {
							this.interSkillsFields.push(obj); // Push objects with category value 1 into category1Array
						}
					});

					this.interValidations = dynamicRules(this.interCustomFieldsArray);
				}
			} catch (error) {
				this.$emit("close");
			} finally {
				if (
					this.singleData &&
					(this.formType == "edit" || this.formType == "editParser") &&
					this.isFirst
				) {
					// Check if uniqueID starts with "INTERPERSONALSKILL" followed by digits (optional)
					if (
						this.singleData.uniqueID &&
						/^INTERPERSONALSKILL\d*$/.test(this.singleData.uniqueID)
					) {
						this.interSkillObject = this.singleData;
						this.selectedInterSkill = this.singleData;
						this.interSkillEdit = true;
					}
				}
				this.interSkillLoader = false;
			}
		},

		async getHobbyFields(type) {
			try {
				this.hobbyLoader = true;
				this.hobbyObject = {};
				this.selectedHobby = {};
				this.hobbyCustomFieldsArray = [];
				this.hobbytouchedFields = {};
				this.hobbyValidations = {};
				this.hobbyObject = {};
				this.hobbyFields = [];
				const customFields = await this.getStaticCustomFields("hobbies", type);

				if (customFields.length) {
					if (type == "add") {
						[
							this.hobbyCustomFieldsArray,
							this.hobbyObject,
							this.hobbytouchedFields,
						] = customFields;
					} else {
						[this.hobbyCustomFieldsArray, this.hobbytouchedFields] =
							customFields;
					}

					// Iterate through the original array and push objects into respective arrays based on category value
					this.hobbyCustomFieldsArray.forEach((obj) => {
						if (obj.category === 1 || obj.category === null) {
							this.hobbyFields.push(obj); // Push objects with category value 1 into category1Array
						}
					});

					this.hobbyValidations = dynamicRules(this.hobbyCustomFieldsArray);
				}
			} catch (error) {
				throw new Error(error);
			} finally {
				if (
					this.singleData &&
					(this.formType == "edit" || this.formType == "editParser") &&
					this.isFirst
				) {
					// Check if uniqueID starts with "INTERPERSONALSKILL" followed by digits (optional)
					if (typeof this.singleData == "string") {
						this.hobbyObject.hobbies = this.singleData;
						this.selectedHobby = this.singleData;
						this.hobbyEdit = true;
					}
				}
				this.hobbyLoader = false;
			}
		},

		async getStaticCustomFields(formID, type) {
			try {
				let response = await getParticularForm(formID);
				if (response.status === 200) {
					this.formDetails = response.data.data.data;
					if (formID === "hobbies") {
						this.hobbiesMandatory = this.formDetails.mandatory;
					}

					const fields =
						this.formID != "achievement"
							? this.formDetails.fields
							: this.formDetails[this.selectedTab];

					const object = {
						customFields: {},
					};
					const touchedFields = {};
					fields.forEach((field) => {
						if (field.fieldType == "default") {
							field.controlType == "multi_select" ||
								field.controlType === "multi_text"
								? (object[field.key] = [])
								: field.controlType === "boolean"
									? (object[field.key] = false)
									: (object[field.key] = "");
							touchedFields[field.key] = false;
						} else {
							field.controlType == "multi_select" ||
								field.controlType === "multi_text"
								? (object["customFields"][field.key] = [])
								: field.controlType === "boolean"
									? (object["customFields"][field.key] = false)
									: (object["customFields"][field.key] = "");
							touchedFields[field.key] = false;
						}
					});

					if (type == "edit") {
						return [fields, touchedFields];
					}
					return [fields, object, touchedFields];
				}
			} catch (error) {
				throw new Error(error);
			}
		},

		getColumn(field) {
			return columnWidth(field, !this.isLaptop);
		},

		deepEqual(obj1, obj2) {
			return JSON.stringify(obj1) === JSON.stringify(obj2);
		},
		skillValidateField(field, newObject, validations, valText, array) {
			const isSkillAlreadyAdded = array.some(
				(skill) =>
					skill.skillName.toLowerCase() === newObject.skillName.toLowerCase()
			);
			const matchingSkill = array.find(
				(skill) =>
					skill.skillName.toLowerCase() === newObject.skillName.toLowerCase()
			);
			const gotPriorityId = matchingSkill ? matchingSkill.priorityID : null;
			const ismatchingPID = gotPriorityId === newObject.priorityID;

			const value =
				field.fieldType === "default"
					? newObject[field.key]
					: newObject.customFields[field.key];

			const rules =
				field.fieldType === "default"
					? validations[field.key]
					: validations.customFields[field.key];

			// Check if the field is required
			if (rules && rules.required) {
				if (field.controlType === "multi_select") {
					if (!Array.isArray(value) || (value && value.length === 0)) {
						valText[field.key] = "Required";
						return false;
					}
				} else {
					// Check if the value is empty or exceeds the character limit
					if (!value) {
						valText[field.key] = "Required";
						return false;
					} else if (field.limit && value.length > field.limit) {
						console.log(field.limit, value.length, "valllllll");

						valText[field.key] = "Max Char Exceeded";
						return false;
					} else if (
						field.key == "skillName" &&
						isSkillAlreadyAdded &&
						!ismatchingPID
					) {
						valText[field.key] = "Skill already exist";
						console.log(isSkillAlreadyAdded, "isSkillAlreadyAdded 2");

						return false;
					}
				}
			} else {
				if (field.limit && value && value.length > field.limit) {
					console.log(field.limit, value.length, "valllllll");

					valText[field.key] = "Max Char Exceeded";
					return false;
				}
			}
			return true;
		},

		// techincal skill start
		getTechError(field) {
			return this.showTechError(field, this.techtouchedFields[field.key]);
		},
		showTechError(field, dirtyStatus) {
			if (dirtyStatus) {
				if (
					!this.skillValidateField(
						field,
						this.techSkillObject,
						this.techValidations,
						this.techValText,
						this.techSkills
					)
				) {
					return true;
				}
			}
			return false;
		},
		getTechVmodel(field) {
			return field.fieldType == "default"
				? this.techSkillObject[field.key]
				: this.techSkillObject.customFields[field.key];
		},

		updateTechFieldValue(field, value) {
			if (field.fieldType === "default") {
				this.$set(this.techSkillObject, field.key, value);
			} else {
				this.$set(this.techSkillObject.customFields, field.key, value);
			}
			console.log(field.key, "chai");

			this.techtouchedFields[field.key] = true;

			this.$forceUpdate();
			this.skillValidateField(
				field,
				this.techSkillObject,
				this.techValidations,
				this.techValText,
				this.techSkills
			);
		},
		validateTechField(field) {
			return this.skillValidateField(
				field,
				this.techSkillObject,
				this.techValidations,
				this.techValText,
				this.techSkills
			);
		},

		validateTechForm() {
			if (this.techCustomFieldsArray.length > 0) {
				let invalidForm = false;
				for (let i = 0; i < this.techCustomFieldsArray.length; i++) {
					const field = this.techCustomFieldsArray[i];
					this.techtouchedFields[field.key] = true;
					this.$forceUpdate();
					if (
						!this.skillValidateField(
							field,
							this.techSkillObject,
							this.techValidations,
							this.techValText,
							this.techSkills
						)
					) {
						invalidForm = true;
					}
				}
				if (!invalidForm) {
					if (this.techSkillEdit) {
						this.updateTechSkill();
					} else {
						this.addTechSkill();
					}
				}
			}
		},
		addTechSkill() {
			let lastElement = this.techSkills.slice(-1);
			if (lastElement.length != 0) {
				if (this.techSkillObject.priorityID == null) {
					this.techSkillObject.priorityID = lastElement[0].priorityID + 1;
				}
			} else {
				if (this.techSkillObject.priorityID == null) {
					this.techSkillObject.priorityID = 1;
				}
			}
			delete this.techSkillObject.customFields;
			this.techSkills.push(this.techSkillObject);

			// for(let key in this.techtouchedFields){
			// 	this.techtouchedFields[key] = false;
			// }
			// this.techSkillObject ={
			// 	skillName:null,
			// 	expertiseLevel:null,
			// 	yearOfExperience:null
			// }

			this.getTechSkillFields("add");
		},
		discardTechSkill() {
			this.techSkillObject = { ...this.selectedTechSkill };
			this.$forceUpdate();
		},
		editTechSkill(skill) {
			this.techSkillObject = { ...skill };
			this.selectedTechSkill = { ...skill };
			console.log(skill, this.selectedTechSkill);

			this.techSkillEdit = true;
		},
		resetCloseCondition(val) {
			this.hideSuggestList = val;
		},
		removeTechSkill(index) {
			this.hideSuggestList = true;
			this.techSkills.splice(index, 1);
		},
		removeParserTechSkill(index) {
			this.hideSuggestList = true;
			this.parserTechSkills.splice(index, 1);
		},
		updateTechSkill() {
			delete this.techSkillObject.customFields;
			if (this.techSkillObject.parser) {
				this.parserTechSkills = this.parserTechSkills.filter((data) => {
					return (
						data.id != this.techSkillObject.id &&
						data.skillName != this.techSkillObject.skillName
					);
				});
				delete this.techSkillObject.parser;
				this.techSkillObject.priorityID =
					this.techSkills.length == 0
						? 1
						: this.techSkills[this.techSkills.length - 1].priorityID;
				console.log(this.techSkills, "techskills");

				this.techSkills.push(this.techSkillObject);
			} else {
				const findSkillInd = this.techSkills.findIndex(
					(skill) => skill.priorityID === this.techSkillObject.priorityID
				);
				this.techSkills[findSkillInd] = this.techSkillObject;
			}
			this.isFirst = false;
			this.selectedTechSkill = {};
			this.techSkillEdit = false;
			this.getTechSkillFields("add");
		},
		// technical skill end

		// Interpersonal skill start
		getInterError(field) {
			return this.showInterError(field, this.intertouchedFields[field.key]);
		},
		showInterError(field, dirtyStatus) {
			if (dirtyStatus) {
				if (
					!this.skillValidateField(
						field,
						this.interSkillObject,
						this.interValidations,
						this.interValText,
						this.interSkills
					)
				) {
					return true;
				}
			}
			return false;
		},
		getInterVmodel(field) {
			return field.fieldType == "default"
				? this.interSkillObject[field.key]
				: this.interSkillObject.customFields[field.key];
		},

		updateInterFieldValue(field, value) {
			if (field.fieldType === "default") {
				this.$set(this.interSkillObject, field.key, value);
			} else {
				this.$set(this.interSkillObject.customFields, field.key, value);
			}
			this.intertouchedFields[field.key] = true;

			this.$forceUpdate();
			this.skillValidateField(
				field,
				this.interSkillObject,
				this.interValidations,
				this.interValText,
				this.interSkills
			);
		},
		validateInterField(field) {
			return this.skillValidateField(
				field,
				this.interSkillObject,
				this.interValidations,
				this.interValText,
				this.interSkills
			);
		},

		validateInterForm() {
			if (this.interCustomFieldsArray.length > 0) {
				let invalidForm = false;
				for (let i = 0; i < this.interCustomFieldsArray.length; i++) {
					const field = this.interCustomFieldsArray[i];
					this.intertouchedFields[field.key] = true;
					this.$forceUpdate();
					if (
						!this.skillValidateField(
							field,
							this.interSkillObject,
							this.interValidations,
							this.interValText,
							this.interSkills
						)
					) {
						invalidForm = true;
					}
				}
				if (!invalidForm) {
					if (this.interSkillEdit) {
						this.updateInterSkill();
					} else {
						this.addInterSkill();
					}
				}
			}
		},
		addInterSkill() {
			let lastElement = this.interSkills.slice(-1);
			if (lastElement.length != 0) {
				if (this.interSkillObject.priorityID == null) {
					this.interSkillObject.priorityID = lastElement[0].priorityID + 1;
				}
			} else {
				if (this.interSkillObject.priorityID == null) {
					this.interSkillObject.priorityID = 1;
				}
			}
			delete this.interSkillObject.customFields;

			this.interSkills.push(this.interSkillObject);

			this.getInterSkillFields("add");
		},
		discardInterSkill() {
			this.interSkillObject = { ...this.selectedInterSkill };
			this.$forceUpdate();
		},
		editInterSkill(skill) {
			this.interSkillObject = { ...skill };
			this.selectedInterSkill = { ...skill };
			console.log(skill, this.selectedInterSkill);

			this.interSkillEdit = true;
		},
		removeInterSkill(index) {
			this.hideSuggestList = true;
			this.interSkills.splice(index, 1);
		},
		removeParserInterSkill(index) {
			this.hideSuggestList = true;
			this.parserInterSkills.splice(index, 1);
		},
		updateInterSkill() {
			delete this.interSkillObject.customFields;
			if (this.interSkillObject.parser) {
				this.parserInterSkills = this.parserInterSkills.filter((data) => {
					return (
						data.id != this.interSkillObject.id &&
						data.skillName != this.interSkillObject.skillName
					);
				});
				delete this.interSkillObject.parser;
				this.interSkillObject.priorityID =
					this.interSkills.length == 0
						? 1
						: this.interSkills[this.interSkills.length - 1].priorityID;
				this.interSkills.push(this.interSkillObject);
			} else {
				const findSkillInd = this.interSkills.findIndex(
					(skill) => skill.priorityID === this.interSkillObject.priorityID
				);
				this.interSkills[findSkillInd] = this.interSkillObject;
			}
			this.selectedInterSkill = {};
			this.interSkillEdit = false;
			this.isFirst = false;
			this.getInterSkillFields("add");
		},
		// Interpersonal skill end

		// Hobby start
		hobbyValidateField(field, newObject, validations, valText) {
			console.log(field, newObject);
			console.log(newObject[field.key], field.key);
			const isHobbyAlreadyAdded = this.hobbies.some(
				(hobby, index) =>
					hobby.toLowerCase() === this.hobbyObject.hobbies.toLowerCase() &&
					index != this.selectedIndex
			);

			console.log(isHobbyAlreadyAdded, "isHobbyAlreadyAdded", field.key);

			const value =
				field.fieldType === "default"
					? newObject[field.key]
					: newObject.customFields[field.key];

			console.log(value);

			const rules =
				field.fieldType === "default"
					? validations[field.key]
					: validations.customFields[field.key];

			// Check if the field is required
			if (rules && rules.required) {
				if (field.controlType === "multi_select") {
					if (!Array.isArray(value) || (value && value.length === 0)) {
						valText[field.key] = "Required";
						return false;
					}
				} else {
					// Check if the value is empty or exceeds the character limit
					if (!value && value.length < 1) {
						valText[field.key] = "Required";
						return false;
					} else if (field.limit && value.length > field.limit) {
						console.log(field.limit, value.length, "valllllll");

						valText[field.key] = "Max Char Exceeded";
						return false;
					} else if (field.key == "hobbies" && isHobbyAlreadyAdded) {
						valText[field.key] = "Hobby already exist";
						console.log(isHobbyAlreadyAdded, "isHobbyAlreadyAdded 2");

						return false;
					}
				}
			} else {
				if (field.limit && value && value.length > field.limit) {
					console.log(field.limit, value.length, "valllllll");

					valText[field.key] = "Max Char Exceeded";
					return false;
				}
			}
			return true;
		},
		getHobbyError(field) {
			return this.showHobbyError(field, this.hobbytouchedFields[field.key]);
		},
		showHobbyError(field, dirtyStatus) {
			if (dirtyStatus) {
				if (
					!this.hobbyValidateField(
						field,
						this.hobbyObject,
						this.hobbyValidations,
						this.hobbyValText
					)
				) {
					return true;
				}
			}
			return false;
		},
		getHobbyVmodel(field) {
			return field.fieldType == "default"
				? this.hobbyObject[field.key]
				: this.hobbyObject.customFields[field.key];
		},

		updateHobbyFieldValue(field, value) {
			if (field.fieldType === "default") {
				this.$set(this.hobbyObject, field.key, value);
			} else {
				this.$set(this.hobbyObject.customFields, field.key, value);
			}
			this.hobbytouchedFields[field.key] = true;

			this.$forceUpdate();
			this.hobbyValidateField(
				field,
				this.hobbyObject,
				this.hobbyValidations,
				this.hobbyValText
			);
		},
		validateHobbyField(field) {
			return this.hobbyValidateField(
				field,
				this.hobbyObject,
				this.hobbyValidations,
				this.hobbyValText
			);
		},

		validateHobbyForm() {
			console.log("hobbyform", this.hobbyObject);

			let invalidForm = false;
			for (let i = 0; i < this.hobbyCustomFieldsArray.length; i++) {
				const field = this.hobbyCustomFieldsArray[i];
				this.hobbytouchedFields[field.key] = true;
				this.$forceUpdate();

				if (
					!this.hobbyValidateField(
						field,
						this.hobbyObject,
						this.hobbyValidations,
						this.hobbyValText
					)
				) {
					invalidForm = true;
				}
			}

			if (!invalidForm) {
				if (this.hobbyEdit || this.isHobbyParser) {
					this.updateHobby();
				} else {
					this.addHobby();
				}
			}
		},
		addHobby() {
			let lastElement = this.hobbies.slice(-1);
			if (lastElement.length != 0) {
				if (this.hobbyObject.priorityID == null) {
					this.hobbyObject.priorityID = lastElement[0].priorityID + 1;
				}
			} else {
				if (this.hobbyObject.priorityID == null) {
					this.hobbyObject.priorityID = 1;
				}
			}
			delete this.hobbyObject.customFields;
			this.hobbies.push(this.hobbyObject["hobbies"]);
			this.getHobbyFields("add");
		},
		discardHobby() {
			this.hobbyObject.hobbies = this.selectedHobby;
			this.$forceUpdate();
		},
		editHobby(hobby, index, parser) {
			this.hobbyObject.hobbies = hobby;
			this.selectedHobby = hobby;
			this.selectedIndex = index;
			this.isHobbyParser = parser;

			this.hobbyEdit = true;
		},
		removeHobby(index) {
			this.hideSuggestList = true;
			this.hobbies.splice(index, 1);
		},
		removeParserHobby(index) {
			this.hideSuggestList = true;
			this.parserHobbies.splice(index, 1);
		},
		updateHobby() {
			delete this.hobbyObject.customFields;
			if (this.isHobbyParser) {
				this.parserHobbies = this.parserHobbies.filter((data) => {
					return data != this.hobbyObject.hobbies;
				});
				this.hobbies.push(this.hobbyObject.hobbies);
			} else {
				const findSkillInd = this.hobbies.findIndex(
					(hobby) => hobby === this.selectedHobby
				);
				this.hobbies[findSkillInd] = this.hobbyObject.hobbies;
			}
			this.selectedHobby = "";
			this.hobbyEdit = false;
			this.isHobbyParser = false;
			this.isFirst = false;
			this.getHobbyFields("add");
		},
		// Interpersonal skill end
		setFormSubmitted() {
			let formDetails = {
				id: this.candidateInfo._id,
				formID: "skills"
			}
			trackFormSubmitted(formDetails)
		},
		async saveSkillsAndHobbies() {
			// console.log("it has unsaved",this.hasUnsavedChanges());
			if (
				this.techSkills.length === 0 &&
				this.interSkills.length === 0 &&
				this.hobbies.length === 0
			) {
				this.errorModal("Error", "Add at least one data");
				this.validateTechForm();
				this.validateInterForm();
				this.validateHobbyForm();
				return;
			}
			try {
				// Validate input
				// Prepare payloads
				this.loader = true;
				const techPayload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					skills: [...this.techSkills, ...this.parserTechSkills],
					parser: this.techSkills.some((obj) => "id" in obj),
				};
				const interPayload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					interpersonalSkills: [...this.interSkills, ...this.parserInterSkills],
					parser: this.interSkills.some((obj) => "id" in obj),
				};

				const hobbyPayload = {
					id: this.candidateInfo._id,
					email: this.candidateInfo.email,
					hobbies: this.hobbies,
					// parserHobbies: this.parserHobbies,
				};
				if (this.parserHobbieTrigger) {
					hobbyPayload.parserHobbies = this.parserHobbies;
				}

				// Clean up unique IDs
				const cleanUpUniqueID = (payload) => {
					payload.skills?.forEach((obj) => delete obj.uniqueID);
					payload.interpersonalSkills?.forEach((obj) => delete obj.uniqueID);
				};
				cleanUpUniqueID(techPayload);
				cleanUpUniqueID(interPayload);
				cleanUpUniqueID(hobbyPayload);

				// Initialize success flags
				let techSuccess = false;
				let interSuccess = false;
				let hobbySuccess = false;

				// Process tech skills
				if (
					this.techSkills.length > 0 ||
					this.candidateInfo.skills.length > 0
				) {
					const techResponse = await postCandSkills(techPayload);
					if (techResponse.status === 200) {
						this.originalTechSkills = [...this.techSkills];
						this.originalInterSkills = [...this.interSkills];
						this.originalHobbies = [...this.hobbies];
						techSuccess = true;
					} else {
						this.errorModal("Error", "Error saving tech skills");
					}
				}

				// Process interpersonal skills
				if (
					this.interSkills.length > 0 ||
					this.candidateInfo.interpersonalSkills.length > 0
				) {
					const interResponse = await postCandInterSkills(interPayload);
					if (interResponse.status === 200) {
						interSuccess = true;
					} else {
						this.errorModal("Error", "Error saving interpersonal skills");
					}
				}

				// Process hobbies
				if (this.hobbies.length > 0 || this.candidateInfo.hobbies.length > 0) {
					const hobbyResponse = await postCandInfo(hobbyPayload);
					if (hobbyResponse.status === 200) {
						hobbySuccess = true;
					} else {
						this.errorModal("Error", "Error saving hobbies");
					}
				}
				// Show consolidated success message
				if (techSuccess && interSuccess && hobbySuccess) {
					this.$emit("show-success", "Skills & Hobbies added successfully");
				} else if (techSuccess || interSuccess) {
					this.$emit("show-success", "Skills added successfully");
				} else if (hobbySuccess) {
					this.$emit("show-success", "Hobbies added successfully");
				}
				this.setFormSubmitted();
				this.$emit("close-modal");
				this.$emit("data-added");
				const isLaptop = window.innerWidth >= 1024;
				if (!isLaptop) {
					this.$router.push({ name: "CandidateDashboard" });
				} else if (!isLaptop && this.$route.query.type === "resumeClinic") {
					this.$router.push({
						name: "CandidateDashboard",
						query: {
							type: "resumeClinic",
						},
					});
				}
			} catch (error) {
				this.errorModal(
					"Error",
					"An error occurred while saving data. Please try again."
				);
			} finally {
				this.$emit("data-added");
				this.loader = false;
				const isLaptop = window.innerWidth >= 1024;
				if (!isLaptop) {
					this.$router.push({ name: "CandidateDashboard" });
				} else if (!isLaptop && this.$route.query.type === "resumeClinic") {
					this.$router.push({
						name: "CandidateDashboard",
						query: {
							type: "resumeClinic",
						},
					});
				}
			}
		},
	},
};
